import { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import heroImage from "../../assets/purepower-home-slider-1.webp";
import homeImg from "../../assets/purepower-home.webp";
import commercialImg from "../../assets/purepower-commercial.webp";
import gridImg from "../../assets/purepower-grid.webp";
import home20Img from "../../assets/new-purepower-grid-2.webp";
import webbanner from "../../assets/web_banner.webp";
import { Zap, PiggyBank, Cpu } from "lucide-react";
import { Link } from "react-router-dom";

const cards = [
  {
    type: "RESIDENTIAL",
    title: "PuREPower Home",
    description:
      "Enjoy uninterrupted power, seamless integration and lower electricity bills.",
    button: "Explore Home →",
    link: "/purepowerresidential",
    image: homeImg,
    tagColor: "bg-green-100 text-green-700",
  },

  {
    type: "COMMERCIAL",
    title: "PuREPower Commercial",
    description:
      "Scalable and efficient energy storage products for your commercial success.",
    button: "Explore Commercial →",
    link: "/purepowercommercial",
    image: commercialImg,
    tagColor: "bg-blue-100 text-blue-700",
  },

  {
    type: "GRID-SCALE",
    title: "PuREPower Grid",
    description:
      "Advanced energy storage products for a stable and sustainable Indian grid.",
    button: "Explore Grid →",
    link: "/purepowergrid",
    image: gridImg,
    tagColor: "bg-purple-100 text-purple-700",
  },
];

const PurePower = () => {
  const formRef = useRef(null);
  const [showPopup, setShowPopup] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [form, setForm] = useState({
    fullName: "",
    phone: "",
    email: "",
    message: "",
  });
  const [errors, setErrors] = useState({});

  const handleSend = (e) => {
    e.preventDefault();

    let err = {};

    if (!form.fullName.trim()) err.fullName = "Full name is required";
    if (!form.phone.trim()) err.phone = "Phone is required";
    if (!form.email.trim()) err.email = "Email is required";
    if (!form.message.trim()) err.message = "Message is required";

    setErrors(err);

    if (Object.keys(err).length) return;

    setIsSending(true);
    setFeedback("");

    emailjs
      .sendForm(
        "service_rsq13gw",
        "template_tol3x69",
        formRef.current,
        "I0r8vNQr0iOJzPWXE"
      )
      .then(() => {
        setForm({
          fullName: "",
          phone: "",
          email: "",
          message: "",
        });
        setErrors({});
        formRef.current?.reset();
        setFeedback("Thank you! Your consultation request has been received.");
        setIsSending(false);
      })
      .catch((error) => {
        console.error(error);
        setFeedback("We could not send your request right now. Please try again later.");
        setIsSending(false);
      });
  };
  return (
    <div>
        
        <section className="bg-black">
            {/* Hero Section */}
            <div className=" relative h-screen bg-cover bg-center flex items-center" style={{backgroundImage: `url(${heroImage})`,}}>
                {/* Overlay */}
                <div className="absolute inset-0 bg-black/35" />

                {/* Content */}
                <div className="relative z-10 px-8 md:px-24 max-w-[700px]">

                <h1 className=" text-white text-5xl md:text-7xl font-bold leading-tight">
                    PuREPower <br />
                    Powering the Future
                </h1>

                <button
                    onClick={() => {
                      setFeedback("");
                      setShowPopup(true);
                    }}
                    className="mt-10 px-8 py-4 rounded-full bg-white text-black text-xl hover:scale-105 transition"
                >
                    Learn More
                </button>

                </div>
            </div>

            {showPopup && (
              <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/70 backdrop-blur-sm p-4 overflow-y-auto">
                <div className="w-full max-w-xl max-h-[90vh] overflow-y-auto rounded-3xl bg-white p-6 shadow-2xl sm:p-7">
                  <div className="flex items-start justify-between gap-4">
                    <div>
                      <p className="text-sm font-semibold uppercase tracking-[0.2em] text-[#00ADA3]">
                        Consultation
                      </p>
                      <h2 className="mt-2 text-2xl font-semibold text-black">
                        Request a Consultation
                      </h2>
                      <p className="mt-2 text-sm text-gray-600">
                        Share your details and our team will contact you shortly.
                      </p>
                    </div>
                    <button
                      type="button"
                      onClick={() => setShowPopup(false)}
                      className="rounded-full border border-gray-300 px-3 py-1 text-xl text-gray-600 hover:bg-gray-100"
                      aria-label="Close popup"
                    >
                      ×
                    </button>
                  </div>

                  {feedback && (
                    <div className={`mt-4 rounded-xl px-4 py-3 text-sm ${feedback.includes("could not") ? "bg-red-50 text-red-700" : "bg-green-50 text-green-700"}`}>
                      {feedback}
                    </div>
                  )}

                  <form ref={formRef} onSubmit={handleSend} className="mt-6 space-y-5">
                    <input
                      type="hidden"
                      name="form_title"
                      value="PuREPower Battery Consultation Request"
                    />

                    <input
                      type="text"
                      name="fullName"
                      placeholder="Full Name"
                      value={form.fullName}
                      onChange={(e) => setForm({ ...form, fullName: e.target.value })}
                      className="w-full rounded-xl border border-gray-300 p-4 outline-none focus:border-[#00ADA3]"
                    />
                    {errors.fullName && <p className="text-sm text-red-500">{errors.fullName}</p>}

                    <input
                      type="tel"
                      name="phone"
                      placeholder="Phone"
                      value={form.phone}
                      onChange={(e) => setForm({ ...form, phone: e.target.value })}
                      className="w-full rounded-xl border border-gray-300 p-4 outline-none focus:border-[#00ADA3]"
                    />
                    {errors.phone && <p className="text-sm text-red-500">{errors.phone}</p>}

                    <input
                      type="email"
                      name="email"
                      placeholder="Email"
                      value={form.email}
                      onChange={(e) => setForm({ ...form, email: e.target.value })}
                      className="w-full rounded-xl border border-gray-300 p-4 outline-none focus:border-[#00ADA3]"
                    />
                    {errors.email && <p className="text-sm text-red-500">{errors.email}</p>}

                    <textarea
                      rows="4"
                      name="message"
                      placeholder="Message"
                      value={form.message}
                      onChange={(e) => setForm({ ...form, message: e.target.value })}
                      className="w-full resize-none rounded-xl border border-gray-300 p-4 outline-none focus:border-[#00ADA3]"
                    />
                    {errors.message && <p className="text-sm text-red-500">{errors.message}</p>}

                    <button
                      type="submit"
                      disabled={isSending}
                      className="w-full rounded-xl bg-black py-4 text-lg text-white transition hover:bg-[#F5B13C] hover:text-black disabled:cursor-not-allowed disabled:opacity-50"
                    >
                      {isSending ? "Sending..." : "Submit Request"}
                    </button>
                  </form>
                </div>
              </div>
            )}
        </section>

        <section className="bg-[#f4f4f4] min-h-screen py-10 px-6 md:px-12">
            {/* Heading */}
            <div className="text-center mb-14">
                <h1 className="text-4xl md:text-6xl font-bold text-black">
                Reliable Energy for Home, Business, and the Grid
                </h1>
                <p className="mt-6 text-xl md:text-3xl text-black">
                PuREPower Products — From Micro to Macro
                </p>
            </div>

            {/* Cards */}
            <div className="max-w-[1500px] mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">
                {cards.map((card, index) => (
                <div
                    key={index}
                    className="bg-white rounded-3xl overflow-hidden border border-gray-200"
                >
                    <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-[400px] object-cover"
                    />

                    <div className="p-7">
                        <span
                            className={`inline-block px-4 py-2 rounded-full text-sm font-medium ${card.tagColor}`}
                        >
                            {card.type}
                        </span>
                        <h2 className="mt-5 text-2xl font-bold text-black">
                            {card.title}
                        </h2>
                        <p className="mt-3 text-gray-600 text-lg leading-8">
                            {card.description}
                        </p>
                        <Link to={card.link} className=" mt-8 inline-block text-green-600 font-semibold hover:translate-x-2 transition ">
                            {card.button}
                        </Link>
                    </div>
                </div>
                ))}
            </div>

            {/* PuREPower Home 20.0 Banner */}
            <div className="max-w-[1500px] mx-auto mt-8 md:mt-16 lg:mt-28">
                <div className="overflow-hidden rounded-3xl shadow-lg">
                    <img
                    src={home20Img}
                    alt="PuREPower Home 20.0"
                    className="w-full h-auto object-cover"
                    />
                </div>
            </div>

            {/* Benefits Cards */}
            <div className="max-w-[1500px] mx-auto mt-8 md:mt-16 lg:mt-28">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">

                    {/* Card 1 */}
                    <div className="bg-white rounded-3xl border border-gray-200 p-8">
                        <div className="w-14 h-14 rounded-2xl bg-green-50 flex items-center justify-center">
                            <Zap size={28} className="text-green-700 fill-green-700" />
                        </div>
                        <div className="w-10 h-1 bg-green-500 rounded mt-5 mb-6"></div>
                        <h3 className="text-[22px] font-bold text-black leading-snug">
                            Seamless power anytime, anywhere
                        </h3>
                        <p className="mt-5 text-gray-600 text-xl leading-10">
                            Never worry about blackouts again. Whether day or
                            night, on-grid or off, you'll always have reliable
                            power when you need it.
                        </p>
                    </div>

                    {/* Card 2 */}
                    <div className="bg-white rounded-3xl border border-gray-200 p-8">
                        <div className="w-14 h-14 rounded-2xl bg-orange-50 flex items-center justify-center">
                            <PiggyBank size={28} className="text-orange-600" />
                        </div>
                        <div className="w-10 h-1 bg-orange-400 rounded mt-5 mb-6"></div>
                        <h3 className="text-[22px] font-bold text-black leading-snug">
                            Save money, store energy, stay connected
                        </h3>
                        <p className="mt-5 text-gray-600 text-xl leading-10">
                            Cut your electricity bills by storing energy.
                            Take control of your energy and reduce costs.
                        </p>
                    </div>

                    {/* Card 3 */}
                    <div className="bg-white rounded-3xl border border-gray-200 p-8">
                        <div className="w-14 h-14 rounded-2xl bg-blue-50 flex items-center justify-center">
                            <Cpu size={28} className="text-blue-600" />
                        </div>
                        <div className="w-10 h-1 bg-blue-500 rounded mt-5 mb-6"></div>
                        <h3 className="text-[22px] font-bold text-black leading-snug">
                            Smart, Efficient, and Future-Proof
                        </h3>
                        <p className="mt-5 text-gray-600 text-xl leading-10">
                            Powered by AI and built for scalability,
                            PuREPower optimizes energy use for maximum
                            efficiency.
                        </p>
                    </div>
                </div>
            </div>

            {/* Web Banner */}
            <div className="max-w-[1500px] mx-auto mt-8 md:mt-16 lg:mt-28">
                <div className="overflow-hidden rounded-3xl shadow-lg">
                    <img
                    src={webbanner}
                    alt="banner"
                    className="w-full h-auto object-cover"
                    />
                </div>
            </div>
        </section>
    </div>
  );
};

export default PurePower;